import { useResource } from '@landsbankinn/l16n';
import {
  Box,
  ColResponsive,
  P,
  RowResponsive,
  TopBarHomeButton,
} from '@landsbankinn/ui-kit';
import { getLandsbankinnUrlByLocale } from '../../getLandsbankinnUrlByLocale';
import { useHeaderTitle } from '../../useHeaderTitle';
import { CultureDropdown } from './CultureDropdown';

export const HEADER_HEIGHT = '80';

export function Header() {
  const title = useHeaderTitle();
  const { locale } = useResource();

  return (
    <RowResponsive
      backgroundWidth="full width"
      as="header"
      height={HEADER_HEIGHT}
      shrink="0"
      background="common gradients darkBlue"
    >
      <ColResponsive xs={8} mainAxisAlignment="center">
        <Box paddingRight="20" paddingLeft="2" position="absolute" left="-68">
          <TopBarHomeButton
            instrumentAs="go_to_home_screen"
            onClick={() =>
              (window.location.href = getLandsbankinnUrlByLocale(locale))
            }
            color="red logo"
          />
        </Box>
        <P
          fontVariant="body"
          fontWeight="medium"
          letterSpacing=".5"
          color="common white"
        >
          {title}
        </P>
      </ColResponsive>
      <ColResponsive xs={4} crossAxisAlignment="end" mainAxisAlignment="center">
        <CultureDropdown />
      </ColResponsive>
    </RowResponsive>
  );
}
